/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progression_High_Rpe_Volume_CutInputs */

const en_us2_progression_high_rpe_volume_cut = /** @type {(inputs: Progression_High_Rpe_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume reduced after very high effort`)
};

const pt_br2_progression_high_rpe_volume_cut = /** @type {(inputs: Progression_High_Rpe_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume reduzido depois de um esforço muito alto`)
};

const es_419_progression_high_rpe_volume_cut = /** @type {(inputs: Progression_High_Rpe_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen reducido tras un esfuerzo muy alto`)
};

const pt_pt2_progression_high_rpe_volume_cut = /** @type {(inputs: Progression_High_Rpe_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume reduzido depois de um esforço muito alto`)
};

const fr_fr2_progression_high_rpe_volume_cut = /** @type {(inputs: Progression_High_Rpe_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume réduit après un effort très intense`)
};

const de_de2_progression_high_rpe_volume_cut = /** @type {(inputs: Progression_High_Rpe_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen nach sehr hoher Anstrengung reduziert`)
};

const it_it2_progression_high_rpe_volume_cut = /** @type {(inputs: Progression_High_Rpe_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume ridotto dopo uno sforzo molto alto`)
};

/**
* | output |
* | --- |
* | "Volume reduced after very high effort" |
*
* @param {Progression_High_Rpe_Volume_CutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_high_rpe_volume_cut = /** @type {((inputs?: Progression_High_Rpe_Volume_CutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_High_Rpe_Volume_CutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_high_rpe_volume_cut(inputs)
	if (locale === "es-419") return es_419_progression_high_rpe_volume_cut(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_high_rpe_volume_cut(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_high_rpe_volume_cut(inputs)
	if (locale === "de-DE") return de_de2_progression_high_rpe_volume_cut(inputs)
	if (locale === "it-IT") return it_it2_progression_high_rpe_volume_cut(inputs)
	return en_us2_progression_high_rpe_volume_cut(inputs)
});
export { progression_high_rpe_volume_cut as "progression.high_rpe_volume_cut" }